// extracted by extract-css-chunks-webpack-plugin
module.exports = {"resellerSelection":"resellerSelection___Vma7q"};